export  const Users = [
    {
      id:1,
      profilePicture:"https://www.stryx.com/cdn/shop/articles/man-looking-attractive.jpg",
      username: "Bhabishya Ghimire",
    },
    {
      id:2,
      profilePicture: "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg?size=626&ext=jpg&ga=GA1.1.840996755.1703237863&semt=sph",
      username: "kane willi",
    },
    {
      id:3,
      profilePicture: "https://img.freepik.com/free-photo/cheerful-indian-businessman-smiling-closeup-portrait-jobs-career-campaign_53876-129417.jpg?w=740&t=st=1704435109~exp=1704435709~hmac=22781d43984a04fa5ae4078e5c39cd9c0cf7b6bee7537c8b9abe3e541fd02183",
      username: "Alex Durden",
    },
    {
      id:4,
      profilePicture: "https://as1.ftcdn.net/v2/jpg/02/11/65/10/1000_F_211651043_dwEPQfpE3acdwhaq0BwZ9xLLBEO3PQRs.jpg",
      username: "Dora Hawks",
    },
    {
      id:5,
      profilePicture: "https://as1.ftcdn.net/v2/jpg/01/91/67/52/1000_F_191675274_IebQK5pVaGmgZvprpIevKIPTovsRZZJi.jpg",
      username: "Thomas Holden",
    },
    {
      id:6,
      profilePicture: "",
      username: "Shirley Beauchamp",
    },
    {
      id:7,
      profilePicture: "",
      username: "Travis Bennett",
    },
    {
      id:8,
      profilePicture: "",
      username: "Kristen Thomas",
    },
    {
      id:9,
      profilePicture: "",
      username: "Gary Duty",
    },
    {
      id:10,
      profilePicture: "",
      username: "Safak Kocaoglu",
    },
  ];
  
  export  const Posts = [
    {
      id: 1,
      desc: "Travelling through train.",
      photo: "",
      date: "5 mins ago",
      userId: 8,
      like: 32,
      comment: 9,
    },
    {
      id: 2,
      photo: "",
      date: "15 mins ago",
      userId: 2,
      like: 2,
      comment: 1,
    },
    {
      id: 3,
      desc: "Every moment is a fresh beginning.",
      photo: "",
      date: "1 hour ago",
      userId: 3,
      like: 61,
      comment: 2,
    },
    {
      id: 4,
      photo: "",
      date: "4 hours ago",
      userId: 4,
      like: 7,
      comment: 3,
    },
    
    {
      id: 6,
      photo: "",
      date: "1 day ago",
      userId: 6,
      like: 44,
      comment: 6,
    },
    {
      id: 7,
      desc: "",
      photo: "",
      date: "2 days ago",
      userId: 7,
      like: 52,
      comment: 3,
    },
    {
      id: 8,
      photo: "",
      date: "3 days ago",
      userId: 8,
      like: 15,
      comment: 1,
    },
    {
      id: 9,
      desc: "Change the world by being yourself.",
      photo: "",
      date: "5 days ago",
      userId: 9,
      like: 11,
      comment: 2,
    },
    {
      id: 10,
      photo: "",
      date: "1 week ago",
      userId: 10,
      like: 104,
      comment: 12,
    },
  ];